// Validation and auto-suffix helpers shared by Create, Rename, and
// batch Move/Upload flows. No storage or worker calls — pure string
// logic.

const MAX_NAME_BYTES = 255;

export function validateName(raw: string, siblings: string[]): string | null {
  const name = raw.trim();
  if (name.length === 0) return "Name cannot be empty.";
  if (new TextEncoder().encode(name).length > MAX_NAME_BYTES) {
    return "Name is too long (max 255 bytes).";
  }
  if (name.includes("/")) return "Name cannot contain a slash.";
  for (const ch of name) {
    const code = ch.codePointAt(0) ?? 0;
    if (code < 0x20 || code === 0x7f) {
      return "Name cannot contain control characters.";
    }
  }
  if (name === "." || name === "..") return "That name is reserved.";
  if (siblings.includes(name)) {
    return `An item named "${name}" already exists here.`;
  }
  return null;
}

// Split a name into (stem, ext) where ext includes the leading dot.
// Dotfiles (".env", ".gitignore") are treated as extensionless.
function splitExt(name: string): [string, string] {
  const lastDot = name.lastIndexOf(".");
  if (lastDot <= 0) return [name, ""];
  return [name.slice(0, lastDot), name.slice(lastDot)];
}

export function autoSuffix(name: string, siblings: string[]): string {
  if (!siblings.includes(name)) return name;
  const [stem, ext] = splitExt(name);
  const taken = new Set(siblings);
  for (let n = 2; n < 10000; n++) {
    const candidate = `${stem} (${n})${ext}`;
    if (!taken.has(candidate)) return candidate;
  }
  // Degenerate fallback: prefix with a timestamp. Not expected in
  // practice but guarantees we never loop forever.
  return `${stem} (${Date.now()})${ext}`;
}
